import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Search = function Search(props) {
  useDeprecatedComponentWarning({
    component: 'Search'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1817 1704l-113 113-421-421q-177 138-402 138-130 0-249.5-49.5T419 1343q-92-92-141.5-211.5T228 881t49.5-250.5T419 419q93-92 212.5-141.5T881 228q131 0 250.5 49.5T1343 419q93 92 142.5 211.5T1535 881q0 224-139 402zM531 1230q145 145 350 145t350-145q144-144 144-349 0-204-144-350-146-144-350-144-205 0-349 144-145 145-145 350t144 349z"
  }));
};

Search.displayName = 'Search';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Search.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Search;